/**
 * ChartWrapper Component - Phase 2C-4
 *
 * Common wrapper for all behavior charts.
 * BSL Compliant: Neutral styling, no interpretive labels.
 */

import { ReactNode } from 'react';
import { Card, CardHeader, CardTitle, CardContent, LoadingSpinner } from '../common';

interface ChartWrapperProps {
  title: string;
  subtitle?: string;
  loading?: boolean;
  error?: string | null;
  empty?: boolean;
  emptyMessage?: string;
  children: ReactNode;
}

export function ChartWrapper({
  title,
  subtitle,
  loading,
  error,
  empty,
  emptyMessage = 'No data available',
  children,
}: ChartWrapperProps): JSX.Element {
  return (
    <Card>
      <CardHeader>
        <div>
          <CardTitle>{title}</CardTitle>
          {subtitle && (
            <p className="text-sm text-slate-400 mt-1">{subtitle}</p>
          )}
        </div>
      </CardHeader>
      <CardContent>
        {loading ? (
          <div className="flex items-center justify-center py-12">
            <LoadingSpinner size="lg" />
          </div>
        ) : error ? (
          <div className="text-center py-12 text-slate-400">
            <p>{error}</p>
          </div>
        ) : empty ? (
          <div className="text-center py-12 text-slate-400">
            <p>{emptyMessage}</p>
          </div>
        ) : (
          <div className="h-64">
            {children}
          </div>
        )}
      </CardContent>
    </Card>
  );
}